
/**
 * Empathy InterfaceX Integration
 * Additional helper functions and event handlers
 */

// Web app splash screen
(function () {
  if (!document.documentElement.classList.contains('brn-standalone')) return;
  const splash = document.getElementById('brn-splash');
  if (!splash) return;
  function hideSplash() {
    splash.classList.add('is-hiding');
    setTimeout(function () { splash.style.display = 'none'; splash.classList.remove('is-hiding'); }, 300);
  }
  if (document.readyState !== 'loading') {
    hideSplash();
  } else {
    document.addEventListener('DOMContentLoaded', hideSplash);
  }
})();


// Empathy: fire addProductToCart on every successful cart add
subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
  const ADD_SOURCES = ['product-form', 'pdp', 'sheet-size', 'wishlist', 'gift-drawer', 'quick-add'];
  if (!ADD_SOURCES.includes(event.source)) return;
  if (typeof InterfaceX !== 'undefined' && typeof InterfaceX.addProductToCart === 'function') {
    console.log('[Empathy] addProductToCart fired, source:', event.source);
    InterfaceX.addProductToCart();
  } else {
    console.warn('[Empathy] addProductToCart not available, source:', event.source);
    InterfaceX.addProductToCart();
  }
});

// Quickbuy datalayer tracking — fires only in sections with data-quickbuy-tracking="true"
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add__to__cart, .variant-elem');
  if (!btn) return;
  if (!btn.closest('[data-quickbuy-tracking]')) return;
  const imageDiv = btn.closest('.brn-card__image');
  const productTitle = imageDiv?.dataset.productTitle
    || btn.closest('.brn-card')?.querySelector('.brn-card__title')?.textContent.trim()
    || '';
  if (window.analyticsUtils?.handleQuickbuyClick) {
    window.analyticsUtils.handleQuickbuyClick(productTitle);
  }
});

// Wait for Empathy InterfaceX to be loaded
window.addEventListener('DOMContentLoaded', function () {
  // Efficiently track when InterfaceX is loaded using event or Promise
  function onInterfaceXReady() {
    // Optional: Add custom event listeners or modifications here
  }

  if (typeof InterfaceX !== 'undefined') {
    // InterfaceX is already loaded
    onInterfaceXReady();
  } else {
    // Listen for a custom event dispatched when InterfaceX is ready
    window.addEventListener('interfaceXReady', onInterfaceXReady, { once: true });

    // Fallback: Promise-based detection if event is not dispatched
    window.interfaceXReadyPromise = new Promise(resolve => {
      const check = setInterval(() => {
        if (typeof InterfaceX !== 'undefined') {
          clearInterval(check);
          onInterfaceXReady();
          resolve();
        }
      }, 300); // Less frequent polling as a fallback

      // Stop checking after 10 seconds
      setTimeout(() => clearInterval(check), 10000);
    });
  }

  initTextSliders();
});

function initTextSliders() {
  const sliders = document.querySelectorAll('.text-slider');
  sliders.forEach(slider => {
    const list = slider.querySelector('ul');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('li'));
    if (items.length <= 1) return;

    // Initial state
    items.forEach((item, index) => {
      if (index === 0) item.classList.add('active');
    });

    let currentIndex = 0;

    setInterval(() => {
      const currentItem = items[currentIndex];
      currentIndex = (currentIndex + 1) % items.length;
      const nextItem = items[currentIndex];

      // Sequence:
      // 1. Current exits (downwards fade out)
      currentItem.classList.remove('active');
      currentItem.classList.add('exit');

      // 2. Next enters (from top fade in)
      nextItem.classList.add('active');

      // 3. Cleanup exit class after transition
      setTimeout(() => {
        currentItem.classList.remove('exit');
      }, 500); // Match CSS transition duration

    }, 3000);
  });
}

// Enhanced close function with visual cleanup
if (typeof window.closeEmpathySearch === 'undefined') {
  window.closeEmpathySearch = function () {
    // Add any custom cleanup logic here
    // For example: hide overlays, reset states, etc.
  };
}

// Fallback for openEmpathySearch if not loaded from snippet
if (typeof window.openEmpathySearch === 'undefined') {
  window.openEmpathySearch = function () {
    if (typeof InterfaceX !== 'undefined' && InterfaceX.search) {
      InterfaceX.search();
    } else {
      console.warn('InterfaceX not loaded yet. Please wait...');
    }
  };
}

function initializeAnimations() {
  // collection-list.liquid animation
  const collectionListObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3,
    trackVisibility: true,
    delay: 300,
  };

  const collectionListObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('visible');
        collectionListObserver.unobserve(entry.target);
      }
    });
  }, collectionListObserverOptions);

  const collectionSections = document.querySelectorAll('.collection-list__container');
  collectionSections.forEach(section => {
    collectionListObserver.observe(section);
  });

  // Banner texts animation
  const texts = document.querySelectorAll('image-banner .line-mask, low-power-video .line-mask');
  const observerText = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observerText.unobserve(entry.target);
        }
      });
    }, {
    // eslint-disable-next-line
    threshold: 0.8
    // eslint-disable-next-line
  }
  );

  texts.forEach(text => observerText.observe(text));
}

function rotateText() {
  const bars = document.querySelectorAll('.bottom-bar');

  bars.forEach(bar => {
    if (bar.dataset.rotating === 'true') {
      return;
    }

    const texts = bar.querySelectorAll('p');
    if (texts.length <= 1) {
      if (texts.length === 1) {
        texts[0].classList.add('active');
      }
      return;
    }

    bar.dataset.rotating = 'true';

    let currentIndex = 0;
    texts[currentIndex].classList.add('active');

    setInterval(() => {
      texts[currentIndex].classList.remove('active');

      setTimeout(() => {
        currentIndex = (currentIndex + 1) % texts.length;
        texts[currentIndex].classList.add('active');
      }, 500);
    }, 3000);
  });
}

// eslint-disable-next-line no-unused-vars
class ScrollAnimationController {
  constructor(imageContainer, firstImage, secondImage) {
    this.imageContainer = imageContainer;
    this.firstImage = firstImage;
    this.secondImage = secondImage;
    this.containerTop = 0;
    this.containerBottom = 0;
    this.containerHeight = 0;
    this.ticking = false;

    this.currentX1 = 0;
    this.targetX1 = 0;
    this.currentX2 = 100;
    this.targetX2 = 100;

    // smooth value
    this.easing = 0.05;

    this.animationFrameId = null;

    this.init();
  }

  updateContainerBounds() {
    const rect = this.imageContainer.getBoundingClientRect();
    this.containerTop = rect.top + window.scrollY;
    this.containerBottom = this.containerTop + rect.height;
    this.containerHeight = rect.height;
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    this.updateContainerBounds();

    const startTrigger = this.containerTop - windowHeight * 0.3;
    const endTrigger = this.containerBottom - windowHeight * 0.5;
    const totalScrollDistance = endTrigger - startTrigger;

    let scrollProgress = 0;

    if (scrollY > startTrigger && scrollY < endTrigger) {
      scrollProgress = ((scrollY - startTrigger) / totalScrollDistance) * 2;
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
    } else if (scrollY >= endTrigger) {
      scrollProgress = 1;
    }

    this.targetX1 = -(scrollProgress * 100);
    this.targetX2 = 100 - scrollProgress * 100;
  }

  smoothAnimate() {
    this.currentX1 += (this.targetX1 - this.currentX1) * this.easing;
    this.currentX2 += (this.targetX2 - this.currentX2) * this.easing;

    this.firstImage.style.transform = `translateX(${this.currentX1}%)`;
    this.secondImage.style.transform = `translateX(${this.currentX2}%)`;

    this.animationFrameId = requestAnimationFrame(this.smoothAnimate.bind(this));
  }

  requestScrollUpdate() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  init() {
    this.firstImage.style.transform = 'translateX(0%)';
    this.secondImage.style.transform = 'translateX(100%)';

    this.updateContainerBounds();
    this.handleScroll();

    this.boundScrollUpdate = this.requestScrollUpdate.bind(this);
    this.boundHandleResize = this.handleResize.bind(this);

    window.addEventListener('scroll', this.boundScrollUpdate);
    window.addEventListener('resize', this.boundHandleResize);

    this.smoothAnimate();

  }

  handleResize() {
    this.updateContainerBounds();
    this.handleScroll();
  }

  destroy() {
    window.removeEventListener('scroll', this.boundScrollUpdate);
    window.removeEventListener('resize', this.boundHandleResize);
    cancelAnimationFrame(this.animationFrameId);
  }
}


// Wishlist class moved to wishlist.js


document.addEventListener('DOMContentLoaded', () => {
  initializeAnimations();
  rotateText();
});

document.addEventListener('shopify:section:load', () => {
  initializeAnimations();
  rotateText();
});

document.addEventListener('shopify:section:reorder', () => {
  initializeAnimations();
  rotateText();
});


//Newsletter form validation
(function () {

  const forms = document.querySelectorAll('.newsletter-form');

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showError(wrapper, errorElement, errorTextElement, message, submitBtn, isEmailError = false) {
    if (isEmailError) {
      wrapper.classList.add('error');
      if (submitBtn) {
        submitBtn.classList.add('btn-error');
        submitBtn.type = 'button'; // Prevent form submission
      }
    }

    if (errorTextElement) {
      errorTextElement.textContent = message;
    }
    errorElement.style.display = 'block';
  }

  function hideError(wrapper, errorElement, removeErrorClass = true, submitBtn = null, isEmailError = false) {
    if (removeErrorClass && isEmailError) {
      wrapper.classList.remove('error');
      if (submitBtn) {
        submitBtn.classList.remove('btn-error');
        submitBtn.type = 'submit'; // Restore form submission
      }
    }
    errorElement.style.display = 'none';
  }

  forms.forEach(function (form) {
    const wrapper = form.closest('.newsletter__wrapper');
    const emailInput = form.querySelector('[type="email"]');
    const privacyCheckbox = form.querySelector('input[name="contact[privacy_policy]"]');
    const emailError = form.querySelector('[id*="email-error"]:not([id*="text"])');
    const emailErrorText = form.querySelector('[id*="email-error-text"]');
    const privacyError = form.querySelector('[id*="privacy-error"]:not([id*="text"])');
    const privacyErrorText = form.querySelector('[id*="privacy-error-text"]');
    const privacyContainer = form.querySelector('.newsletter__privacy');
    const privacyPolicyWrapper = form.querySelector('[id*="privacy-policy-wrapper"]'); // NEW

    const submitBtn = form.querySelector('.brn-newsletter__btn');

    if (!emailInput || !emailError) return;

    // Check if form was posted successfully via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const successWrapper = form.querySelector('.newsletter__success-wrapper');

    if (urlParams.get('customer_posted') === 'true' && successWrapper) {
      // Newsletter signup succeeded — surface it through the unified toaster.
      const successText = successWrapper.textContent.trim();
      if (window.toast && successText) {
        window.toast.show(successText, { type: 'success', icon: 'email' });
      }
    }

    // Add click event to X icon to clear error and focus input
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (this.classList.contains('btn-error') && wrapper.classList.contains('error')) {
          e.preventDefault();
          e.stopPropagation();
          hideError(wrapper, emailError, true, submitBtn, true);
          emailInput.value = ''; // Clear the input
          emailInput.focus();
        }
      });
    }

    // Show privacy checkbox on first focus
    let hasBeenFocused = false;
    emailInput.addEventListener('focus', function () {
      if (!hasBeenFocused && privacyContainer) {
        privacyContainer.style.display = 'block';
        hasBeenFocused = true;
      }
      if (privacyPolicyWrapper) {
        privacyPolicyWrapper.classList.remove('newsletter-form__privacy-policy--hidden');
      }

    }, { once: false });

    emailInput.addEventListener('blur', function (e) {
      // Don't validate on blur if clicking the submit button
      // The submit event will handle validation
      if (e.relatedTarget === submitBtn) {
        return;
      }

      const email = this.value.trim();

      if (email === '') {
        showError(wrapper, emailError, emailErrorText, window.formValidation.requiredEmailStr, submitBtn, true);
      } else if (!isValidEmail(email)) {
        showError(wrapper, emailError, emailErrorText, window.formValidation.validEmailStr, submitBtn, true);
      } else {
        hideError(wrapper, emailError, true, submitBtn, true);
      }
    });

    emailInput.addEventListener('input', function () {
      const email = this.value.trim();

      if (email !== '' && isValidEmail(email)) {
        hideError(wrapper, emailError, true, submitBtn, true);
      }
    });

    if (privacyCheckbox && privacyError) {
      privacyCheckbox.addEventListener('change', function () {
        if (this.checked) {
          hideError(wrapper, privacyError, true, submitBtn, false);
        }
      });
    }

    form.addEventListener('submit', function (e) {
      const email = emailInput.value.trim();
      let hasErrors = false;

      // Check email errors
      const emailEmpty = email === '';
      const emailInvalid = !emailEmpty && !isValidEmail(email);

      if (emailEmpty || emailInvalid) {
        hasErrors = true;
      }

      // Check privacy checkbox error (only if visible)
      const privacyVisible = (privacyContainer && privacyContainer.style.display !== 'none')
        || (privacyPolicyWrapper && !privacyPolicyWrapper.classList.contains('newsletter-form__privacy-policy--hidden'));

      const privacyUnchecked = privacyVisible && privacyCheckbox && !privacyCheckbox.checked;

      if (privacyUnchecked) {
        hasErrors = true;
      }
      if (!hasErrors) {
        window.analyticsUtils.handleLead(email);
      }

      // If there are ANY errors, prevent submit
      if (hasErrors) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Show errors
        if (emailEmpty) {
          showError(wrapper, emailError, emailErrorText, window.formValidation.requiredEmailStr, submitBtn, true);
        } else if (emailInvalid) {
          showError(wrapper, emailError, emailErrorText, window.formValidation.validEmailStr, submitBtn, true);
        } else {
          hideError(wrapper, emailError, true, submitBtn, true);
        }

        if (privacyUnchecked && privacyError) {
          showError(wrapper, privacyError, privacyErrorText, window.formValidation.privacyPolicyStr, submitBtn, false);
        } else if (privacyError) {
          hideError(wrapper, privacyError, true, submitBtn, false);
        }

        // Focus on first error
        if (emailEmpty || emailInvalid) {
          emailInput.focus();
        } else if (privacyUnchecked && privacyCheckbox) {
          privacyCheckbox.focus();
        }

        return false;
      }

    });
  });
})();

// @note Loader overlay removido del grid; el contenedor reserva espacio vía aspect-ratio

function watchAndDeleteElements(selector) {
  const processElement = (el) => {
    if (el.dataset.timeoutStarted) return;
    el.dataset.timeoutStarted = "true";
    setTimeout(() => {
      if (el.parentNode) {
        el.remove();
      }
    }, 4000);
  };

  document.querySelectorAll(selector).forEach(processElement);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(selector).forEach(processElement);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

watchAndDeleteElements('.form__success-message');


// --- Empathy search: single sync point for all open/close paths ---
// Wraps window.open/closeEmpathySearch so any caller (trigger button,
// extended search X, drawer search) keeps every UI in sync: header brand
// class, trigger icon (search <-> X), and isOpen state.
(function () {
  try {
    const headerBrand = document.querySelector('.wt-header__brand');
    function syncSearchState(open) {
      if (headerBrand) headerBrand.classList.toggle('search--open', open);
      const trigger = window.empathySearchTrigger;
      if (trigger) {
        trigger.isOpen = open;
        if (typeof trigger.updateIcon === 'function') trigger.updateIcon(open);
      }
    }
    const originalOpen = window.openEmpathySearch;
    const originalClose = window.closeEmpathySearch;
    window.openEmpathySearch = function () {
      if (typeof originalOpen === 'function') {
        try { originalOpen.apply(this, arguments); } catch { }
      }
      syncSearchState(true);
    };
    window.closeEmpathySearch = function () {
      if (typeof originalClose === 'function') {
        try { originalClose.apply(this, arguments); } catch { }
      }
      syncSearchState(false);
    };
    // Safety: always reset on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.code === 'Escape') syncSearchState(false);
    });
  } catch { }
})();

// --- NaizFit: Recommendation UI ---
// Single source of truth for the "¿Cuál es mi talla?" / "Mi talla es la X"
// message shown across 4 surfaces (PDP inline slot, size-guide modal,
// #sheet-size, cart size modal) plus the green-dot marker on the main PDP
// size picker. Availability (in stock or not) is never part of the message
// text — the size row itself (dot/disabled state) already communicates that.
(function () {
  if (document.documentElement.lang === 'ca') return;
  const LS_KEY = 'naiz_recommended_size';

  function getRecommendedSize() {
    try { return localStorage.getItem(LS_KEY) || ''; } catch (e) { return ''; }
  }

  // `root` narrows the first-choice lookup to a surface's own [data-size-value]
  // list (sheet-size / cart modal); the fallback checks the main variant
  // picker, scoped to `fallbackRoot` (defaults to `root`) so callers bound to
  // one specific picker instance don't cross-match another hidden copy of it.
  function findSizeInput(recLower, root, fallbackRoot) {
    root = root || document;
    fallbackRoot = fallbackRoot || root;
    let input = Array.from(root.querySelectorAll('input[data-size-value]'))
      .find(function (i) { return i.dataset.sizeValue.toLowerCase() === recLower; }) || null;
    if (!input) {
      input = Array.from(fallbackRoot.querySelectorAll('variant-options input[data-option-type="size"]'))
        .find(function (i) { return i.value.toLowerCase() === recLower; }) || null;
    }
    return input;
  }

  // exists = the cached size is a real option on THIS product — guards
  // against a size recommended for a different product with a different
  // size scale (e.g. "P" cached, this product only has numeric sizes).
  // available = exists AND in stock.
  function getSizeAvailability(rec, root, fallbackRoot) {
    if (!rec) return { input: null, exists: false, available: false };
    const input = findSizeInput(rec.toLowerCase(), root, fallbackRoot);
    return { input: input, exists: !!input, available: !!(input && !input.disabled) };
  }

  // Exposed for component-sheet-size.liquid's inline <script> (a separate
  // scope from this IIFE) so it doesn't need its own 4th copy of this logic.
  window.__naizFitCore = {
    getRecommendedSize: getRecommendedSize,
    findSizeInput: findSizeInput,
    getSizeAvailability: getSizeAvailability,
  };

  function renderNaizfitMessage(container, naizfitDiv, rec, availability) {
    // Cache coat-hanger icon on first render (lost after innerHTML is replaced)
    const iconEl = naizfitDiv.querySelector('.svg-icon');
    if (iconEl) naizfitDiv._naizIconHTML = iconEl.outerHTML;
    const iconHTML = naizfitDiv._naizIconHTML || '';

    const hasRecommendation = availability.exists;
    const txtTemplate = hasRecommendation
      ? (naizfitDiv.dataset.txtAvailable || '')
      : (naizfitDiv.dataset.txtNoRecommendation || '');
    if (!txtTemplate) return;
    const message = hasRecommendation ? txtTemplate.replace('__SIZE__', rec) : txtTemplate;

    // #naiz-opener-container is a single, page-wide element that gets moved
    // (not cloned) between the PDP's home slot, #sheet-size, and the
    // size-guide modal — querying only inside naizfitDiv missed it whenever
    // another surface currently held it. Re-fetch and re-append it for any
    // surface that already owns it (the home slot renders it as a direct
    // child in Liquid) or legitimately claims it (#sheet-size, size-guide's
    // <modal-dialog>) — but never for the cart's size modal, which should
    // never steal it away from wherever it legitimately lives.
    const alreadyHosted = !!naizfitDiv.querySelector('#naiz-opener-container');
    const openerEl = (alreadyHosted || container.id === 'sheet-size' || container.tagName === 'MODAL-DIALOG')
      ? document.getElementById('naiz-opener-container')
      : null;

    naizfitDiv.classList.toggle('brn-sheet-size__naizfit--recommended', hasRecommendation);
    // Only render our own <p> when there's a recommendation ("Mi talla es la
    // X") — NaizFit's own button is forced below to a *different* label
    // ("Modificar") in that case, so both are meaningful side by side. With
    // no recommendation, NaizFit's button already carries that exact copy
    // ("¿Cuál es mi talla?"); adding our own <p> with the same text would
    // just duplicate it.
    const messageHTML = hasRecommendation
      ? '<p class="brn-sheet-size__naizfit__message">' + message + '</p>'
      : '';
    naizfitDiv.innerHTML = iconHTML + messageHTML;
    if (openerEl) naizfitDiv.appendChild(openerEl);

    // Force NaizFit's own button text to match — its own relabel doesn't
    // reliably refresh, and we want one canonical copy everywhere.
    const naizBtn = document.getElementById('naiz-sizeform-opener');
    if (naizBtn) {
      const txtLabel = hasRecommendation
        ? (naizfitDiv.dataset.txtModify || '')
        : (naizfitDiv.dataset.txtNoRecommendation || '');
      if (txtLabel) naizBtn.textContent = txtLabel;
    }

    // Highlight the recommended row in this surface's own size list (only
    // when in stock). #sheet-size already gets this from
    // MobileSizeModal.markRecommendedSize() on every open() — doing it again
    // here would glue a second badge onto the same label.
    if (container.id !== 'sheet-size') {
      container.querySelectorAll('.brn-sheet-size__list__item').forEach(function (li) {
        li.classList.remove('is-recommended');
        const existing = li.querySelector('.variant-tooltip--recommended');
        if (existing) existing.remove();
      });
      if (availability.available) {
        const li = availability.input.closest('.brn-sheet-size__list__item');
        if (li) {
          li.classList.add('is-recommended');
          const txtRecommended = naizfitDiv.dataset.txtRecommended || '';
          if (txtRecommended) {
            const badge = document.createElement('div');
            badge.className = 'variant-tooltip variant-tooltip--recommended';
            badge.innerHTML = iconHTML + txtRecommended;
            const label = li.querySelector('.brn-sheet-size__label');
            if (label) label.appendChild(badge);
          }
        }
      }
    }
  }

  // #naiz-opener-container is a single, page-wide element NaizFit's bundle
  // populates asynchronously once it loads — true regardless of which
  // surface currently hosts it (home slot, #sheet-size, size-guide). Used as
  // the one signal for "is NaizFit actually operational right now", so no
  // surface shows our "¿Cuál es mi talla?"/"Mi talla es la X" copy before
  // NaizFit has proven it can paint something — a page where the script is
  // blocked/misconfigured should show nothing, same as before this whole UI
  // was consolidated, rather than a label with no working button behind it.
  function isNaizFitReady() {
    const container = document.getElementById('naiz-opener-container');
    return !!(container && container.children.length > 0);
  }

  // `container` is either the [data-naizfit-ui] element itself (the PDP home
  // slot) or an ancestor containing one plus its own size list (sheet-size,
  // cart modal, size-guide <modal-dialog>).
  function updateNaizfitUI(container) {
    if (!isNaizFitReady()) return;

    const naizfitDiv = container.matches('[data-naizfit-ui]') ? container : container.querySelector('[data-naizfit-ui]');
    if (!naizfitDiv) return;

    const rec = getRecommendedSize();
    const availability = getSizeAvailability(rec, container, document);
    renderNaizfitMessage(container, naizfitDiv, rec, availability);
  }

  // Refreshes every [data-naizfit-ui] surface that's currently visible (the
  // home slot counts as always "visible" — no open/is-open gate applies to
  // it). Shared by: the moment NaizFit first paints its button (see
  // observeNaizOpenerContainer below), and after every selectSize() call
  // (see patchSelectSize below) — both are "NaizFit's state just changed"
  // moments where every open surface needs to catch up.
  // Reentrancy guard: renderNaizfitMessage() mutates the DOM (innerHTML wipe +
  // appendChild to reclaim #naiz-opener-container), and observers elsewhere
  // could in principle call back into this synchronously — hard-stop any
  // nested call instead of letting it recurse.
  let isRefreshingSurfaces = false;
  function refreshVisibleSurfaces() {
    if (isRefreshingSurfaces) return;
    isRefreshingSurfaces = true;
    try {
      document.querySelectorAll('[data-naizfit-ui]').forEach(function (naizfitDiv) {
        const modal = naizfitDiv.closest('#sheet-size, [data-cart-size-modal], modal-dialog') || naizfitDiv;
        const isHomeSlot = modal === naizfitDiv;
        const isOpen = isHomeSlot || modal.classList.contains('is-open') || modal.hasAttribute('open');
        if (!isOpen) return;
        updateNaizfitUI(modal);

        // The size row's green "Tu Talla" mark is owned by
        // MobileSizeModal.markRecommendedSize() (component-sheet-size.liquid),
        // which otherwise only runs once when the sheet opens — re-run it here
        // too, or the mark stays stale while the shopper changes their answers
        // with the sheet still open.
        if (modal.id === 'sheet-size' && window.mobileSizeModal && typeof window.mobileSizeModal.markRecommendedSize === 'function') {
          window.mobileSizeModal.markRecommendedSize();
        }
      });
    } finally {
      isRefreshingSurfaces = false;
    }
  }

  // Debug helpers — useful to diagnose on first deploy without naizfit running
  window.__naizDebug = {
    updateUI: function () {
      const modal = document.querySelector('[data-cart-size-modal].is-open');
      if (modal) {
        updateNaizfitUI(modal);
      } else { console.log('[naizfit-ui] No open cart size modal. Open one first.'); }
    },
    getRec: function () { return getRecommendedSize(); },
    setRec: function (size) {
      localStorage.setItem(LS_KEY, size);
      console.log('[naizfit-ui] Recommendation set to "' + size + '". Call __naizDebug.updateUI() to refresh.');
    },
    clearRec: function () {
      localStorage.removeItem(LS_KEY);
      console.log('[naizfit-ui] Recommendation cleared.');
    }
  };

  // Update UI when a cart size modal is opened
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-size-modal-id]');
    if (!btn) return;
    setTimeout(function () {
      const modal = document.getElementById(btn.getAttribute('data-cart-size-modal-id'));
      if (modal && modal.classList.contains('is-open')) {
        updateNaizfitUI(modal);
      }
    }, 100);
  }, false);

  // Update UI when the product page mobile size sheet opens
  const sheetSize = document.getElementById('sheet-size');
  if (sheetSize) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && sheetSize.classList.contains('is-open')) {
          updateNaizfitUI(sheetSize);
        }
      });
    }).observe(sheetSize, { attributes: true });
  }

  // Update UI when the size-guide <modal-dialog> opens — same reasoning as
  // #sheet-size above: a returning shopper with an already-stored
  // recommendation needs the message rendered as soon as this modal opens,
  // not only after a fresh selectSize() call (see patchSelectSize below).
  document.querySelectorAll('[data-naizfit-ui]').forEach(function (naizfitDiv) {
    const modalDialog = naizfitDiv.closest('modal-dialog');
    if (!modalDialog) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && modalDialog.hasAttribute('open')) {
          updateNaizfitUI(modalDialog);
        }
      });
    }).observe(modalDialog, { attributes: true });
  });

  // #naiz-opener-container is a static node present at parse time; only its
  // child button arrives asynchronously once NaizFit's bundle loads. The
  // moment that happens is exactly when isNaizFitReady() flips from false to
  // true for every surface at once — refresh all of them right then, instead
  // of guessing a fixed timeout (the previous
  // setTimeout(updateNaizButtonLabel, 200) silently no-op'd whenever NaizFit
  // took longer than 200ms, and only covered the home slot). The observer
  // travels with the container if size-chart.js/relocateNaizContainer()
  // later move it elsewhere, since it's attached to the container itself.
  function observeNaizOpenerContainer() {
    const container = document.getElementById('naiz-opener-container');
    if (!container) return;
    refreshVisibleSurfaces(); // in case it's already populated (e.g. bfcache restore)
    // childList only (no subtree) — watching subtree would also fire on any
    // internal DOM churn NaizFit does *inside* the button it injects, and
    // every one of those firings runs refreshVisibleSurfaces(), which moves
    // this very container via appendChild elsewhere (see renderNaizfitMessage
    // in updateNaizfitUI). That move disconnects/reconnects it, which can
    // make NaizFit's own component re-render its internals, which mutates
    // the subtree again — a tight feedback loop that pegs the CPU and starves
    // NaizFit's own script (matches component-sheet-size.liquid's
    // relocateNaizContainer(), which uses the same plain childList watch).
    // Moving `container` itself (our appendChild elsewhere) is a childList
    // change on its *parent*, not on `container`'s own children, so it never
    // re-triggers this observer.
    new MutationObserver(refreshVisibleSurfaces).observe(container, { childList: true });
  }
  observeNaizOpenerContainer();

  // Override selectSize to capture naizfit recommendation
  function patchSelectSize() {
    if (
      !window.naizjs ||
      !window.naizjs.SizeForm ||
      typeof window.naizjs.SizeForm.prototype.selectSize !== 'function'
    ) {
      return false;
    }

    const orig = window.naizjs.SizeForm.prototype.selectSize;
    window.naizjs.SizeForm.prototype.selectSize = function (size) {
      try { localStorage.setItem(LS_KEY, size); } catch (e) { }
      window.dispatchEvent(new CustomEvent('naizfit:recommendation-updated'));

      // NaizFit's own bundle, when a returning shopper already has a saved
      // profile, calls selectSize() on page load with NO tap from the
      // shopper — and internally it selects the matching size radio in a way
      // the browser reports as event.isTrusted === true (confirmed via a
      // captured call stack: onVariantChange <- naizjs's own selectSize <-
      // this very wrapper). variants.js's onVariantChange relies on
      // isTrusted to decide dataset.userSelected, which is meant to gate
      // shouldShowMobileSizeModal() — so an untouched page load was silently
      // marking a size as shopper-picked and skipping the confirmation sheet.
      // Flag this window so onVariantChange can tell NaizFit's own
      // auto-select apart from a real tap, regardless of isTrusted.
      window.__naizFitAutoSelecting = true;
      let result;
      try {
        result = orig.apply(this, arguments);
      } finally {
        window.__naizFitAutoSelecting = false;
      }

      // The MutationObserver/click listeners above only catch the moment a
      // modal *opens* — if the shopper reopens NaizFit's own form and
      // changes their answers while a modal stays open, selectSize fires
      // again but nothing re-renders the message already on screen.
      setTimeout(refreshVisibleSurfaces, 200);

      return result;
    };

    return true;
  }

  let pollAttempts = 0;
  const maxPollAttempts = 60; // 30s at 500ms intervals
  var pollInterval = setInterval(function () {
    pollAttempts++;
    if (patchSelectSize()) {
      clearInterval(pollInterval);
    } else if (pollAttempts >= maxPollAttempts) {
      console.warn('[naizfit-ui] naizjs.SizeForm not available after 30s — selectSize not patched');
      clearInterval(pollInterval);
    }
  }, 500);
})();

// --- NaizFit: Recommended size marker for the main PDP size selector ---
(function () {
  if (document.documentElement.lang === 'ca') return;

  function clearRecommendedMarks(root) {
    root.querySelectorAll('.f-button__list__item.is-recommended').forEach(function (li) {
      li.classList.remove('is-recommended');
      const dot = li.querySelector('.f-button__status-dot--recommended');
      if (dot) dot.remove();
      const tooltip = li.querySelector('.variant-tooltip--recommended');
      if (tooltip) tooltip.remove();
    });
  }

  function markPickerRecommendedSize(root) {
    clearRecommendedMarks(root);

    const rec = window.__naizFitCore.getRecommendedSize();
    const input = window.__naizFitCore.findSizeInput(rec.toLowerCase(), root, root);

    if (!input || input.disabled || input.classList.contains('is-sold-out') || input.classList.contains('is-coming-soon')) {
      return;
    }

    const label = input.nextElementSibling;
    const li = input.closest('.f-button__list__item');
    if (!li || !label) return;

    li.classList.add('is-recommended');

    const dot = document.createElement('span');
    dot.className = 'f-button__status-dot f-button__status-dot--recommended';
    label.appendChild(dot);

    const tooltip = document.createElement('div');
    tooltip.className = 'variant-tooltip variant-tooltip--recommended';
    tooltip.textContent = (window.variantStrings && window.variantStrings.recommendedLabel) || '';
    li.appendChild(tooltip);

    // Desktop only: auto-select the recommendation as a convenience, since there
    // is no confirmation step afterwards. On mobile the shopper still has to go
    // through the size sheet (#sheet-size) before adding to cart — pre-checking
    // the input here would make shouldShowMobileSizeModal() think a size was
    // already picked and skip that sheet entirely, silently adding the
    // recommended size without ever showing it to the shopper.
    if (window.innerWidth < 1024) return;

    const hasCheckedSize = Array.from(root.querySelectorAll('input[data-option-type="size"]')).some(function (el) { return el.checked; });
    if (!hasCheckedSize) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function markAll() {
    document.querySelectorAll('variant-options').forEach(function (root) {
      if (root.querySelector('input[data-option-type="size"]')) {
        markPickerRecommendedSize(root);
      }
    });
  }

  setTimeout(markAll, 200);
  window.addEventListener('naizfit:recommendation-updated', markAll);
})();

function closeOthers(openedCollapsible) {
  document.querySelectorAll('.brn-product__info collapsible-section').forEach(el => {
    if (el !== openedCollapsible && el.dataset.open === 'true') {
      el.querySelector('.wt-collapse__trigger').click();
    }
  });
}

// Watch for attribute changes using MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'data-open'
    ) {
      const target = mutation.target;
      if (target.dataset.open === 'true') {
        closeOthers(target);
      }
    }
  });
});

// Observe all collapsibles
document.querySelectorAll('.brn-product__info collapsible-section').forEach(el => {
  observer.observe(el, { attributes: true });
});

// Open cart drawer if ?showCart=true and remove only that param.
// UTM params must stay in the URL so GTM/GA4 can attribute the visit.
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('showCart')) return;

  const shouldOpenCart = urlParams.get('showCart') === 'true';
  urlParams.delete('showCart');
  const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
  history.replaceState(null, '', cleanUrl);

  if (shouldOpenCart) {
    window.addEventListener('load', function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.toggleDrawerClasses === 'function' && !cartDrawer.isOpen) {
        cartDrawer.toggleDrawerClasses();
      }
    });
  }
})();
